import React from "react";
import { Form, Row, Col, Modal, Typography } from "antd";
const { Title } = Typography;
function ViewProduct({ visible, onClose, Product }) {
  function formatDate(date) {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(date).toLocaleDateString("en-US", options);
    const [month, day, year] = formattedDate.split(" ");
    const capitalizedMonth = month.toUpperCase();
    return `${day} ${capitalizedMonth} ${year}`;
  }
  return (
    <>
      <Modal
        footer={[]}
        width={500}
        visible={visible}
        onCancel={onClose}
        onOk={onClose}
        maskClosable={false}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          View Individual Product
        </Title>
        <Form
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          className="FormClass IndividualProduct-Model"
        >
          <>
            {Product && (
              <>
                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Created Date</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">
                      : &nbsp;{" "}
                      {Product?.productCreateDate
                        ? formatDate(Product?.productCreateDate)
                        : ""}
                    </h6>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Product Name</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.productName}</h6>
                  </Col>
                </Row>
                
                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Product Code</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.productCode}</h6>
                  </Col>
                </Row>
                
                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Currency</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.currency}</h6>
                  </Col>
                </Row>
                
                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Unit UOM 1</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.unitUomOne}</h6>
                  </Col>
                </Row>
                
                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Unit UOM 2</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.unitUomTwo}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Unit of Measurement 1</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">
                      : &nbsp;{Product?.unitOfMeasurement1}
                    </h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Unit of Measurement 2</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">
                      : &nbsp; {Product?.unitOfMeasurement2}
                    </h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Cost Price per UoM 1</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.costPriceUoM1}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Cost Price per UoM 2</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.costPriceUoM2}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Selling Price UoM 1</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">
                      : &nbsp; {Product?.sellingPriceUoM1}
                    </h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Selling Price UoM 2</b> <br />
                    </h6>
                  </Col>
                  <Col span={8}>
                    <h6 className="pt-2">
                      : &nbsp; {Product?.sellingPriceUoM2}
                    </h6>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Supplier</b> <br />
                    </h6>
                  </Col>
                  <Col span={13}>
                    <h6 className="pt-2">: &nbsp; {Product?.supplierDTO?.map(item => item?.supplierName)?.join(',')}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Department</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp; {Product?.department}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Allergens</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp;{Product?.allergens}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Shelf Life</b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp;{Product?.shelfLifeDTO?.description}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Cooling Shelf Life</b> <br />
                    </h6>
                  </Col>
                  <Col span={13}>
                    <h6 className="pt-2">: &nbsp;{Product?.coolingShelfLifeDTO?.description}</h6>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={11}>
                    <h6 className="pt-2">
                      <b>Storage Suggestions
                      </b> <br />
                    </h6>
                  </Col>
                  <Col span={10}>
                    <h6 className="pt-2">: &nbsp;{Product?.storageSuggestionDTO?.name}</h6>
                  </Col>
                </Row>
              </>
            )}
          </>
        </Form>
      </Modal>
    </>
  );
}

export default ViewProduct;
